import { createContext, useState } from 'react';

import CredentialTypeData from './CredentialTypeData';

export const CredentialTypeStateContext = createContext();

const CredentialTypeContextProvider = ({ children }) => {
  const stateHook = useState(CredentialTypeData.INITIAL_STATE);

  return (
    <CredentialTypeStateContext.Provider value={stateHook}>
      {children}
    </CredentialTypeStateContext.Provider>
  );
};

export default CredentialTypeContextProvider;